import React, { useLayoutEffect, useRef } from 'react';
import './product-carousel.css';

const CANVAS_WIDTH = 1000;

/* Draws a slide on the fixed 1000 x 950 canvas and scales it to the width of its container.
   The scale is written to a CSS variable (--pc-scale) so no inline styles are needed. */
const SlideCanvas = ({ children, thumb = false, fill = false }) => {
  const ref = useRef(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const apply = () => el.style.setProperty('--pc-scale', String(el.clientWidth / CANVAS_WIDTH));
    apply();
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', apply);
      return () => window.removeEventListener('resize', apply);
    }
    const observer = new ResizeObserver(apply);
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} className={`pc-canvas${thumb ? ' pc-thumb' : ''}${fill ? ' pc-fill' : ''}`} aria-hidden={thumb || undefined}>
      <div className="pc-slide">{children}</div>
    </div>
  );
};

export default SlideCanvas;
